import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {RecordAudioPanelProps} from '@Panels/record-audio-panel/record-audio-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'record-audio-panel';
export type RecordAudioModalProps = Omit<RecordAudioPanelProps, 'panelId'>;

export default function RecordAudioModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.RECORD_AUDIO_MODAL];
  });
  const height = '628px';
  const mobileHeight = '536px';
  const maxWidth = '870px';

  return (
    <Modal
      modalId={MODALS_IDS.RECORD_AUDIO_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={mobileHeight}
      isBottomSheetOnMobile
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="record-audio-panel"
        panelProps={{
          panelId: PANEL_ID,
          ...modalData.panelProps,
        }}
      />
    </Modal>
  );
}

export const openRecordAudioModal = (props: RecordAudioModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.RECORD_AUDIO_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        ...props,
      },
    })
  );
};
